import React from "react";
import { CourseData } from "./CourseData";
import { Link, Routes, Route, useNavigate } from "react-router-dom";

function Course() {
  const navigate = useNavigate();

  return (
    <>
      <div className="row">
        <div class="list-group col-xs-12 col-sm-12 col-md-2 col-lg-2 p-3 ">
          {CourseData.map((el) => {
            return (
              <label class="list-group-item">
                <Link
                  onClick={(e) => {
                    navigate(`${el.path}`); //e.target.parentElement.parentElement.style.display = "none"
                  }}
                  to={el.path}
                  className="list-item"
                >
                  <input className="form-check-input me-1" type="checkbox" />
                  <span className="mx-1">{el.title}</span>
                </Link>
              </label>
            );
          })}
        </div>
        <div className="course-content col-xs-12 col-sm-12 col-md-9 col-lg-9  ">
          <Routes>
            {CourseData.map((el) => {
              return <Route path={`${el.path}`} element={el.element} />;
            })}
          </Routes>
        </div>
      </div>
    </>
  );
}

export default Course;
